import tokenUtils from "../../utils/token";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
    const token = tokenUtils.getToken();
    if (!token) {
        return <Navigate to="/login" />;
    }
    return (
        <>
            {children}
        </>
    );
}